var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.type === "daterange"
        ? _c("el-date-picker", {
            staticStyle: { height: "100%" },
            attrs: {
              type: "daterange",
              clearable: "",
              "range-separator": _vm.$t("placeHolder.to"),
              "start-placeholder":
                _vm.placeholderspan + _vm.$t("placeHolder.start"),
              "end-placeholder":
                _vm.placeholderspan + _vm.$t("placeHolder.end"),
              size: "mini"
            },
            on: { change: _vm.handleDateChange, clear: _vm.handleClear },
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          })
        : _vm.type === "date"
        ? _c("el-date-picker", {
            staticStyle: { height: "100%" },
            attrs: {
              type: "datetime",
              clearable: "",
              placeholder: _vm.placeholderspan,
              size: "mini"
            },
            on: { change: _vm.handleDateChange, clear: _vm.handleClear },
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          })
        : _c("el-date-picker", {
            staticStyle: { height: "100%" },
            attrs: {
              type: _vm.type,
              clearable: "",
              placeholder: _vm.placeholderspan,
              size: "mini"
            },
            on: { change: _vm.handleDateChange, clear: _vm.handleClear },
            model: {
              value: _vm.localValue,
              callback: function($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }